/**
 * The name of a field as the content type declares it, for a path the page
 * editor or the history reports (`meta.description`, `faq/2/question`). A raw
 * path is how the machine addresses a value, not how a person recognises it:
 * "Meta › Descrizione" is. Segments the type does not declare are turned into
 * words; list indexes become "n. 3".
 */
import type { FieldDefinition } from '@cms/contracts'
import { humanize } from './format.js'

function labelOf(field: FieldDefinition, locale: string): string {
  return field.label?.[locale] ?? field.label?.it ?? humanize(field.key)
}

export function labelForPath(fields: readonly FieldDefinition[], path: string, locale: string): string {
  const segments = path.split(/[./]/).filter(Boolean)
  const labels: string[] = []
  let level: readonly FieldDefinition[] | undefined = fields
  for (const segment of segments) {
    if (/^\d+$/.test(segment)) {
      labels.push(locale === 'en' ? `no. ${Number(segment) + 1}` : `n. ${Number(segment) + 1}`)
      continue
    }
    const field: FieldDefinition | undefined = level?.find((candidate) => candidate.key === segment)
    labels.push(field ? labelOf(field, locale) : humanize(segment))
    level = field?.of
  }
  return labels.join(' › ') || path
}
